// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ZF_3X","icon":"styles_icon___Hns4","text":"styles_text__GsZ7X"};